(function() {
  "use strict";
  angular.module("marketPlace.email", []);
})();
